<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <!-- <el-input
        size="medium"
        v-model="searchForm.nodeName"
        placeholder="请输入节点名称"
        @keyup.enter.native="getTableList"
      ></el-input>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">查询</el-button> -->
    </div>
    <div class="searchRight">
      <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc">增加</el-button>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    :span-method="objectSpanMethod"
    height="73vh"
    style="width: 100%">
    <el-table-column
      prop="coinName"
      label="币种名称">
    </el-table-column>
    <el-table-column
      prop="multiAuditAmount"
      label="风控金额">
    </el-table-column>
    <el-table-column
      prop="multiAuditNum"
      label="审批人数">
    </el-table-column>
    <el-table-column
      prop="multiChain"
      width="110"
      label="是否为多链币">
      <template slot-scope="scope">
        <span >{{scope.row.multiChain==1?'是':'否'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="multiChain"
      label="是否展示">
      <template slot-scope="scope">
        <span >{{scope.row.isDisplay==1?'是':'否'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="linkName"
      label="支持链路">
    </el-table-column>
    <el-table-column
      prop="rechargeStatus"
      label="充币状态">
      <template slot-scope="scope">
        <span>{{scope.row.rechargeStatus==1?'正常':'关闭'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="cashOutStatus"
      label="提币状态">
      <template slot-scope="scope">
        <span>{{scope.row.cashOutStatus==1?'正常':'关闭'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="serviceFee"
      width="100"
      label="提币手续费">
    </el-table-column>
    <el-table-column
      prop="minCashOutNum"
      width="110"
      label="最小提币数量">
    </el-table-column>
    <el-table-column
      prop="cashOutThreshold"
      width="110"
      label="自动提币阈值">
    </el-table-column>
    <el-table-column
      prop="safeWithdrawalThreshold"
      width="110"
      label="安全提币阈值">
    </el-table-column>
    <el-table-column
      width="140px"
      prop="identityWithdrawalThreshold"
      label="身份认证提币阈值">
    </el-table-column>
    <el-table-column
      prop="linkIsDisplay"
      width="110"
      label="链路是否展示">
      <template slot-scope="scope">
        <span>{{scope.row.linkIsDisplay==1?'是':'否'}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="createTime"
      width="160"
      label="更新时间">
      <template slot-scope="scope">
        <span>{{$selfFunc.dayjsFunc(scope.row.createTime)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" type="primary" @click="cancel(scope.row)"><i class="el-icon-setting" style="margin-right:3px;"></i>编辑</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.page"
      :page-sizes="[20, 50, 100, 500]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalNum"
    >
    </el-pagination>
  </div>
    <el-dialog
    :title="type==1?'新增币种':'编辑币种'"
    :visible.sync="dialogVisible"
    width="450px">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="138px" class="demo-ruleForm">
      <el-form-item label="币种名称" prop="coinName">
        <el-input placeholder="请输入币种名称" v-model.trim="ruleForm.coinName" style="width:220px" type="text" :disabled="type==1?false:true"></el-input>
      </el-form-item>
      <el-form-item label="风控金额" prop="multiAuditAmount">
        <el-input placeholder="请输入风控金额" v-model.trim="ruleForm.multiAuditAmount" oninput ="value=value.replace(/[^0-9.]/g,'')" style="width:220px" type="text" ></el-input>
      </el-form-item>
      <el-form-item label="审批人数" prop="multiAuditNum">
        <el-input placeholder="请输入审批人数" v-model.trim="ruleForm.multiAuditNum" oninput ="value=value.replace(/[^0-9.]/g,'')"  style="width:220px" type="text" ></el-input>
      </el-form-item>
      <el-form-item label="是否多链" prop="multiChain">
        <el-radio-group v-model="ruleForm.multiChain">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="资产列表是否显示" prop="isDisplay" >
        <el-radio-group v-model="ruleForm.isDisplay">
          <el-radio label="1">是</el-radio>
          <el-radio label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>  
      <div style="height:460px;overflow-y: scroll;">
        <div v-for="(item,index) in ruleForm.apiAr" :key="index">
          <div style="text-align: center;margin-bottom: 10px;font-size: 14px;font-weight: bold;">链路{{index+1}}</div>
          <el-form-item label="支持链路" :prop="'apiAr.'+index+'.linkName'" :rules="rules.linkName">
            <el-input placeholder="请输入支持链路" v-model.trim="item.linkName" style="width:220px" type="text" ></el-input>
          </el-form-item>
          <el-form-item label="充币状态" :prop="'apiAr.'+index+'.rechargeStatus'" :rules="rules.rechargeStatus">
            <el-radio-group v-model="item.rechargeStatus">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="提币状态" :prop="'apiAr.'+index+'.cashOutStatus'" :rules="rules.cashOutStatus">
            <el-radio-group v-model="item.cashOutStatus">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手续费" :prop="'apiAr.'+index+'.serviceFee'" :rules="rules.serviceFee">
            <el-input placeholder="请输入手续费" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model.trim="item.serviceFee" style="width:220px" type="number" ></el-input>
          </el-form-item>
          <el-form-item label="最小提币数" :prop="'apiAr.'+index+'.minCashOutNum'" :rules="rules.minCashOutNum">
            <el-input placeholder="请输入最小提币数" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model.trim="item.minCashOutNum" style="width:220px" type="number" ></el-input>
          </el-form-item>
          <el-form-item label="自动阈值" :prop="'apiAr.'+index+'.cashOutThreshold'" :rules="rules.cashOutThreshold">
            <el-input placeholder="请输入自动提币阈值" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model.trim="item.cashOutThreshold" style="width:220px" type="number" ></el-input>
          </el-form-item>
          <el-form-item label="安全提币阈值" :prop="'apiAr.'+index+'.safeWithdrawalThreshold'" :rules="rules.safeWithdrawalThreshold">
            <el-input placeholder="请输入安全提币阈值" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model.trim="item.safeWithdrawalThreshold" style="width:220px" type="number" ></el-input>
          </el-form-item>
          <el-form-item label="身份认证提币阈值" :prop="'apiAr.'+index+'.identityWithdrawalThreshold'" :rules="rules.identityWithdrawalThreshold">
            <el-input placeholder="请输入身份认证提币阈值" oninput ="value=value.replace(/[^0-9.]/g,'')" v-model.trim="item.identityWithdrawalThreshold" style="width:220px" type="number" ></el-input>
          </el-form-item>
          <el-form-item label="链路是否显示" :prop="'apiAr.'+index+'.isDisplay'" :rules="rules.isDisplay">
            <el-radio-group v-model="item.isDisplay">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <span @click="delAdd(index)" v-if="ruleForm.apiAr.length>1">删除</span>
        </div>
        <div class="add-api"  >
          <span @click="addApis()" style="margin-right:20px" v-if="ruleForm.multiChain==1">新增</span>
          
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: 1,
      coinId: '',
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
      },
      tableData: [],
      dialogVisible:false,
      // mineNumberNo: '',
      ruleForm:{
        coinName: '',
        multiChain: '1',
        isDisplay: '1',
        multiAuditAmount: null,
        multiAuditNum: null,
        apiAr: []
      },
      apiAr:{
        linkName: '',
        rechargeStatus: '1',
        cashOutStatus: '1',
        serviceFee: '',
        minCashOutNum: '',
        cashOutThreshold: '',
        isDisplay: '1',
        identityWithdrawalThreshold: '',
        safeWithdrawalThreshold: '',
      },
      rules:{
        coinName: [
          { required: true, message: '请输入币种名称', trigger: 'blur' },
        ],
        multiAuditAmount: [
          { required: true, message: '请输入风控金额', trigger: 'blur' },
        ],
        multiAuditNum: [
          { required: true, message: '请输入审批人数', trigger: 'blur' },
        ],
        multiChain:[
          { required: true, message: '请选择是否多链', trigger: 'blur' }
        ],
        linkName: [
          { required: true, message: '请输入支持链路名称', trigger: 'blur' }
        ],
        rechargeStatus: [
          { required: true, message: '请选择充币状态', trigger: 'blur' }
        ],
        cashOutStatus: [
          { required: true, message: '请选择提币状态', trigger: 'blur' }
        ],
        minCashOutNum: [
          { required: true, message: '请输入最小提币数量', trigger: 'blur' },
        ],
        serviceFee: [
          { required: true, message: '请输入手续费', trigger: 'blur' },
        ],
        cashOutThreshold: [
          { required: true, message: '请输入自动阈值', trigger: 'blur' },
        ],
        safeWithdrawalThreshold: [
          { required: true, message: '请输入安全提币阈值', trigger: 'blur' },
        ],
        identityWithdrawalThreshold: [
          { required: true, message: '请输入身份认证提币阈值', trigger: 'blur' }
        ],
        isDisplay: [
          { required: true, message: '请选择资产列表是否展示状态', trigger: 'blur' }
        ],
        
      },
    };
  },
  created() {
    this.addApis();
    this.getTableList()
  },
  watch: {
    'ruleForm.multiChain':function(val){
    
    }
  },
  methods: {
    addApis() {
      this.ruleForm.apiAr.push({ ...this.apiAr });
    },
    delAdd(i) {
      //删除api
      let self = this;
      self.ruleForm.apiAr.splice(i, 1);
    },
    getCent(row) {
      sessionStorage.setItem("minerCode", row.nodeNumber);
      this.$router.push({ name: 'centsAuditNew'});
    },
    resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    getNumber (num) {
      return num.toFixed(2)
    },
    cancel(row) {
      this.type = 2
      this.dialogVisible=true;
      this.coinId = row.coinId
      this.eidDetail()
    },
    async eidDetail() {
      let res = await this.$http.coinQuery({modelId:this.coinId})
      if (res) {
        console.log(res)
        this.ruleForm.coinName= res.data.coinName
        this.ruleForm.multiAuditAmount = res.data.multiAuditAmount
        this.ruleForm.multiAuditNum = res.data.multiAuditNum
        this.ruleForm.multiChain = res.data.multiChain.toString()
        this.ruleForm.isDisplay= res.data.isDisplay.toString()
        let arr = []
        res.data.appCoinLinkList.map((item)=>{
          let obj = {
            linkName: item.linkName,
            rechargeStatus: item.rechargeStatus.toString(),
            cashOutStatus: item.cashOutStatus.toString(),
            serviceFee: item.serviceFee.toString(),
            minCashOutNum: item.minCashOutNum.toString(),
            cashOutThreshold: item.cashOutThreshold.toString(),
            isDisplay: item.isDisplay.toString(),
            safeWithdrawalThreshold: item.safeWithdrawalThreshold.toString(),
            identityWithdrawalThreshold: item.identityWithdrawalThreshold.toString()
          }
          arr.push(obj)
        })
        this.ruleForm.apiAr = arr
      }
    },
    submitForm(formName) {
      console.log(this.ruleForm)
      let _this = this
      if(_this.ruleForm.multiChain==1&&_this.ruleForm.apiAr.length<=1) {
        _this.$message.error('因您选择了多链路币种，当前仅配置了一个链路，请配置其他链路信息。');
        return false
      }
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let list = JSON.stringify(_this.ruleForm.apiAr)
          let data = {}
          if (_this.type==1) {
            data = {
              coinName: _this.ruleForm.coinName,
              isDisplay: _this.ruleForm.isDisplay,
              multiChain: _this.ruleForm.multiChain,
              multiAuditAmount: _this.ruleForm.multiAuditAmount,
              multiAuditNum: _this.ruleForm.multiAuditNum,
              linkListStr: list
            }
          }else {
            data = {
              coinName: _this.ruleForm.coinName,
              multiAuditAmount: _this.ruleForm.multiAuditAmount,
              multiAuditNum: _this.ruleForm.multiAuditNum,
              isDisplay: _this.ruleForm.isDisplay,
              multiChain: _this.ruleForm.multiChain,
              linkListStr: list,
              coinId: _this.coinId
            }
          }
          let res = await _this.$http.coinSaveOrUpdate(data);
          if (res) {
            _this.$message.success('操作成功！');
            _this.dialogVisible=false;
            _this.$nextTick(() => {
              _this.$refs['ruleForm'].resetFields()
            })
            _this.getTableList()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    addFunc(){
      this.$nextTick(() => {
				this.$refs['ruleForm'].resetFields()
			})
      this.type = 1
      this.ruleForm={
        coinName: '',
        multiChain: '1',
        apiAr: [
          {
            linkName: '',
            rechargeStatus: '1',
            cashOutStatus: '1',
            serviceFee: '',
            minCashOutNum: '',
            cashOutThreshold: '',
            isDisplay: '1',
            safeWithdrawalThreshold: '',
            identityWithdrawalThreshold: ''
          }
        ]
      }
      this.dialogVisible=true;
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.coinConfig({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(this.tableData)
          this.totalNum = Number(res.data.totalSize)
          this.tableData.forEach(v => {
            v.rowspan = 1;
          });
          // 双层循环
          for (let i = 0; i < this.tableData.length; i++) {
            for (let j = i + 1; j < this.tableData.length; j++) {
              if (this.tableData[i].coinName === this.tableData[j].coinName) {
                this.tableData[i].rowspan++;
                this.tableData[j].rowspan--;
              }
            }
            // 这里跳过已经重复的数据
            i = i + this.tableData[i].rowspan - 1;
          }
        }
    },
    // handleTableData(data) {
    //   let arr = []
    //   let on = 0
    //   let spanNum=0
    //   for(let i = 0;i<data.length;i++) {
    //     let house_info = data[i].
    //   }
    // },
     objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1
        };
      }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style scoped>
.add-api{
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
